/* Meta (Facebook) Pixel integration */

export const META_PIXEL_ID = '1352396107105753'

let initialized = false

function getFbq(): any {
  if (typeof window === 'undefined') return undefined
  return (window as any).fbq
}

/**
 * Loads the Meta Pixel base code, initializes the pixel, and fires PageView.
 * Safe to call multiple times — initialization only runs once.
 */
export function initMetaPixel() {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  const w = window as any

  // Set up the fbq command queue (mirrors the official Meta Pixel snippet).
  if (!w.fbq) {
    function fbq(this: any) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, arguments as any)
      } else {
        fbq.queue.push(arguments)
      }
    }
    ;(fbq as any).queue = []
    ;(fbq as any).push = fbq
    ;(fbq as any).loaded = true
    ;(fbq as any).version = '2.0'

    w.fbq = fbq
    if (!w._fbq) w._fbq = fbq

    // Inject the Meta Pixel script safely.
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const target = document.head || document.body || document.documentElement
    if (target) target.appendChild(script)
  }

  w.fbq('init', META_PIXEL_ID)
  w.fbq('track', 'PageView')
}

/**
 * Fires the standard AddToCart event. Call right before redirecting to checkout.
 */
export function trackAddToCart(data?: {
  value?: number
  currency?: string
  content_name?: string
}) {
  const fbq = getFbq()
  if (!fbq) return
  fbq('track', 'AddToCart', data)
}
